import React from "react";
import { Grid, withStyles } from "@material-ui/core";
import CardDetalhesFarol from "features/manejo/views/components/cardDetalhesFarol";
import { TextLabel } from "features/shared/components";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslations } from "adapters/i18n";

export const DetalhesFazenda = (props) => {
  const {
    quantidadeRebanhoTodasCategorias,
    quantidadeRebanhoNoCurral,
    nomeFazenda,
    pesoMedioTodasCategorias,
    classes,
  } = props;

  const { t } = useTranslations();

  const renderNomeFazenda = () => {
    return (
      <Grid
        container
        direction="row"
        justify="space-between"
        className={classes.nomeFazendaContainer}
      >
        <TextLabel
          id="labelNomeFazenda"
          label={`${t("locales:farm")} ${nomeFazenda}`}
          bold
          color="default3"
          size={14}
        />
      </Grid>
    );
  };

  const stringQtdRebanhoPasto = quantidadeRebanhoTodasCategorias
    ? quantidadeRebanhoTodasCategorias.toString()
    : "0";

  const stringQtdRebanhoCurral = quantidadeRebanhoNoCurral
    ? quantidadeRebanhoNoCurral.toString()
    : "0";
  const totalRebanho = quantidadeRebanhoTodasCategorias + quantidadeRebanhoNoCurral;
  const pesoMedioKg =
    typeof pesoMedioTodasCategorias === "number"
      ? pesoMedioTodasCategorias
      : pesoMedioTodasCategorias?.kg || 0;
  const pesoMedioArroba =
    typeof pesoMedioTodasCategorias === "number"
      ? null
      : pesoMedioTodasCategorias?.arroba;

  return (
    <CardDetalhesFarol
      primaryCard
      tituloCard={t("common:total")}
      subTituloCard={renderNomeFazenda()}
    >
      <Box sx={{ width: "100%", maxWidth: 500 }}>
        <Typography variant="body2" gutterBottom className={classes.text}>
          {t("statusIndicator:total-animals-in-pastures")}:{" "}
          <b>
            {stringQtdRebanhoPasto}
          </b>
        </Typography>

        <Typography
          variant="body2"
          gutterBottom
          className={`${classes.text} total-curral`}
        >
          {t("statusIndicator:total-animals-in-corrals")}:{" "}
          <b>{stringQtdRebanhoCurral}</b>
        </Typography>

        <Typography
          variant="body2"
          gutterBottom
          className={`${classes.text} total-pastos-currais`}
        >
          {t("statusIndicator:total-animals-in-pastures-and-corrals")}:{" "}
          <b>{totalRebanho}</b>
        </Typography>
        <Typography
          variant="body2"
          gutterBottom
          className={`${classes.text} peso-medio`}
        >
          {t("statusIndicator:average-visual-weight")}:{" "}
          <b>{`${pesoMedioKg.toFixed(0)} ${t("common:measure.KG")}`}</b>
        </Typography>
        {pesoMedioArroba !== null && pesoMedioArroba !== undefined && (
          <Typography
            variant="body2"
            gutterBottom
            className={`${classes.text} peso-medio-arroba`}
          >
            {t("statusIndicator:weight-in-arrobas")}:{" "}
            <b>{`${pesoMedioArroba.toFixed(0)}${t("common:measure.arroba")}`}</b>
          </Typography>
        )}
      </Box>
    </CardDetalhesFarol>
  );
};

const styles = (theme) => ({
  nomeFazendaContainer: {
    margin: "15px 0",
  },
  title: {
    color: theme.palette.primary.main,
    padding: "20px 0",
  },
  text: {
    color: "#757575",
    fontWeight: "normal",
    padding: "5px 0",
  },
});

const detalhesFazendaIgual = (prevProps, nextProps) => {
  const quantidadeRebanhoIgual =
    prevProps.quantidadeRebanhoTodasCategorias ===
    nextProps.quantidadeRebanhoTodasCategorias;
  const quantidadeNoCurralIgual =
    prevProps.quantidadeRebanhoNoCurral === nextProps.quantidadeRebanhoNoCurral;
  const nomeFazendaIgual = prevProps.nomeFazenda === nextProps.nomeFazenda;
  return quantidadeRebanhoIgual && quantidadeNoCurralIgual & nomeFazendaIgual;
};

const detalhesFazendaMemo = React.memo(DetalhesFazenda, detalhesFazendaIgual);

export default withStyles(styles)(detalhesFazendaMemo);
